import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import CSSModules from 'react-css-modules';
import { MailOpenedIcon } from '@client/components/shared/SvgIcons';
import DoiSuccessAlert from '../doiSuccessAlert/DoiSuccessAlert';
import DoiSuccessResendLink from '../doiSuccessResendLink/DoiSuccessResendLink';
import Translate from '@client/components/shared/translation/Translate';
import { track } from '@client/helpers';
import {
    getParamEmailProvider,
    getParamSendingConfirmationEmail,
    getAlert,
} from '@client/redux/modules/successOverlay/selectors';
import { sendConfirmationEmail } from '@client/redux/modules/successOverlay/actions';
import { getEmail } from '@client/redux/modules/customer/selectors';
import {
    ALERT_ERROR,
    ALERT_SUCCESS,
} from '@client/redux/modules/successOverlay/constants';
import styles from './doiSuccessContent.scss';

const RESEND_LIMIT = 3;
const instructions = ['instruction1', 'instruction2', 'instruction3'];

export class DoiSuccessContent extends PureComponent {
    static propTypes = {
        closeOverlay: PropTypes.func.isRequired,
        sendConfirmationEmail: PropTypes.func.isRequired,
        emailProvider: PropTypes.string,
        isSendingConfirmationEmail: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        alert: PropTypes.shape({
            type: PropTypes.oneOf([ALERT_SUCCESS, ALERT_ERROR]),
            message: PropTypes.string,
        }),
    };

    state = {
        resendCounter: 0,
    };

    render() {
        const {
            alert,
            email,
            emailProvider,
            isSendingConfirmationEmail,
        } = this.props;

        return (
            <div styleName="doi-success-wrapper">
                <div styleName="header">
                    <h1 styleName="header-title">
                        <Translate message="header" />
                    </h1>
                    {email && (
                        <h2 styleName="header-sub">
                            <Translate message="sub" params={{ email }} html />
                        </h2>
                    )}
                </div>
                <div styleName="container">
                    <div styleName="icon">
                        <MailOpenedIcon width="42" height="42" />
                    </div>
                    <div styleName="content">
                        <h2>
                            <Translate message="instructionsHeader" />
                        </h2>
                        <ul styleName="instructions">
                            {instructions.map(instruction => (
                                <li>
                                    <Translate message={instruction} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {emailProvider && (
                    <button styleName="button" onClick={this.trackGoToInbox}>
                        <Translate message="gotoInbox" />
                    </button>
                )}
                <div styleName="resend-wrapper">
                    {alert ? (
                        <DoiSuccessAlert {...alert} />
                    ) : (
                        this.state.resendCounter < RESEND_LIMIT && (
                            <DoiSuccessResendLink
                                isLoading={isSendingConfirmationEmail}
                                onClick={this.handleSendConfirmationEmail}
                            />
                        )
                    )}
                </div>
            </div>
        );
    }

    trackGoToInbox = () => {
        window.open(`http://www.${this.props.emailProvider}`, '_blank');
        track('doi.email.gotoInboxCta');
    };

    handleSendConfirmationEmail = ev => {
        ev.preventDefault();

        const { intl } = this.props;
        this.props
            .sendConfirmationEmail({
                errorMessage: intl.formatMessage({
                    id: 'sendingFailed',
                }),
                successMessage: intl.formatMessage({
                    id: 'sent',
                }),
            })
            .then(() => {
                track('doi.email.resendCta');

                // After some tries we disable the button to prevent users going crazy
                this.setState(prevState => ({
                    resendCounter: prevState.resendCounter + 1,
                }));
            });
    };
}

const mapStateToProps = state => ({
    email: getEmail(state),
    emailProvider: getParamEmailProvider(state),
    isSendingConfirmationEmail: getParamSendingConfirmationEmail(state),
    alert: getAlert(state),
});

const mapDispatchToProps = {
    sendConfirmationEmail,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(CSSModules(DoiSuccessContent, styles, { allowMultiple: true })));
